import { render, staticRenderFns } from "./ButtonThree.vue?vue&type=template&id=a3e23224&"
import script from "./ButtonThree.vue?vue&type=script&lang=ts&"
export * from "./ButtonThree.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports